import { IonContent } from '@ionic/react';
import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context.tsx';
import { canLogEvents } from '@/utils/canLogEvents.ts';

import {
  AnimationContainer,
  SubtitleStyles,
  TitleStyles,
} from './SelfConfidenceGraph.styles.ts';

export const ScreenSelfConfidenceGraph: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Self confidence graph',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  return (
    <OnboardingPage>
      <IonContent>
        <TitleStyles>
          Dialogue will help you to gain your self-confidence!
        </TitleStyles>
        <SubtitleStyles variant={'body-large'} color={'neutral-black'}>
          Regular chats improve your communication skills and help you feel more
          confident in any situation!
        </SubtitleStyles>

        <AnimationContainer>
          <Player
            autoplay
            keepLastFrame
            src="/assets/self-confidence-animation.json"
          />
        </AnimationContainer>
      </IonContent>

      <OnboardingFooter onContinue={wizard.nextStep} />
    </OnboardingPage>
  );
};
